import React, { Component } from 'react'
import './SellerServicesContainer.less'
import { Header, Icon, Segment, Table, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { getSellerServices, toggleServiceForSeller } from '../../services/Services';

class SellerServicesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            services: [],
            allSelected: false
        }
    }

    async componentDidMount() {
        getSellerServices().then((res) => {
            if (res.resStatus == 200) {
                let unSelectedServices = res.data.filter((item) => { return item.isActive == false });
                if (unSelectedServices.length > 0) {
                    this.setState({ allSelected: false })
                } else if (unSelectedServices.length == 0) {
                    this.setState({ allSelected: true })
                }
                this.setState({ services: res.data })
            }
        });
    }

    handleServiceCheck = (serviceID, checked) => {
        this.updateServiceStatus(serviceID, checked);
    }

    updateServiceStatus = async (serviceID, checked) => {
        let serviceState = this.state.services;

        let serviceObjectIndex = serviceState.findIndex((ser) => { return ser.serviceID == serviceID })

        if (serviceObjectIndex != -1) {

            serviceState[serviceObjectIndex].isActive = checked;

            let serviceList = [{
                serviceID: serviceID,
                isActive: checked,
            }]

            let res = await toggleServiceForSeller(serviceList);

            if (res.resStatus == 200) {
                this.setState({ services: [...serviceState] })
            }
            let unSelectedServices = serviceState.filter((item) => { return item.isActive == false });
            if (unSelectedServices.length > 0) {
                this.setState({ allSelected: false });
            } else if (unSelectedServices.length == 0) {
                this.setState({ allSelected: true });
            }
        }
    }

    handleSelectAllServiceClick = async (checked) => {
        if (checked) {
            let servicesList = this.state.services;
            let unSelectedServices = servicesList.filter((item) => { return item.isActive == false });
            let serviceList = [];
            unSelectedServices.forEach((ser) => {
                serviceList.push({
                    serviceID: ser.serviceID,
                    isActive: true
                });
            });
            let res = await toggleServiceForSeller(serviceList);
            if (res.resStatus == 200) {
                this.setState({ allSelected: true, services: [...servicesList.map((s) => { return { ...s, isActive: true } })] })
            }
        } else {
            let servicesList = this.state.services;
            let selectedServices = servicesList.filter((item) => { return item.isActive == true });
            let serviceList = [];
            selectedServices.forEach((ser) => {
                serviceList.push({
                    serviceID: ser.serviceID,
                    isActive: false
                });
            });
            let res = await toggleServiceForSeller(serviceList);
            if (res.resStatus == 200) {
                this.setState({ allSelected: false, services: [...servicesList.map((s) => { return { ...s, isActive: false } })] })
            }
        }
    }

    render() {
        return (
            <>
                <Segment.Group>
                    <Segment size="massive" className="no-radius">
                        <Header as="h1">
                            <Header.Content>
                                <Icon name='bell' size='small' />
                                Services
                            </Header.Content>
                        </Header>
                    </Segment>
                </Segment.Group>
                <Segment.Group>
                    <Segment size="massive" className="no-radius">
                        <Table celled striped>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        Service
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Active
                                        {
                                            <Checkbox toggle className={"select-all-checkbox"}
                                                disabled
                                                onChange={(e, data) => this.handleSelectAllServiceClick(data.checked)}
                                                checked={this.state.allSelected} />
                                        }
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    this.state.services.length == 0 && <Table.Row>
                                        <Table.Cell colspan="3">
                                            No Service found.
                                        </Table.Cell>
                                    </Table.Row>
                                }
                                {this.state.services.length > 0 && <>
                                    {
                                        _.map(this.state.services, ser => {
                                            return <Table.Row>
                                                <Table.Cell>
                                                    {ser.name}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {
                                                        <Checkbox
                                                            disabled
                                                            toggle
                                                            onChange={(e, data) => this.handleServiceCheck(ser.serviceID, data.checked)}
                                                            checked={ser.isActive} />
                                                    }
                                                </Table.Cell>
                                            </Table.Row>
                                        })
                                    }
                                </>}
                            </Table.Body>
                        </Table>
                    </Segment>
                </Segment.Group>
            </>
        )
    }
}

const mapStateToProps = ({ auth: { currentUser } }) => {
    return { currentUser };
}

export default connect(mapStateToProps, null)(SellerServicesContainer)